import { useRef } from 'react'
import { Dialog } from './Dialog'
import { TextField } from '@mui/material'
import { textFieldStyle } from '../utils/constants'

export type ChangePasswordFunc = (password: string) => Promise<void>

export const ChangePasswordDialog = ({
  onSubmitPassword,
  onClose,
}: {
  onSubmitPassword: ChangePasswordFunc
  onClose: Function
}) => {
  const passwordField1 = useRef<HTMLInputElement>()
  const passwordField2 = useRef<HTMLInputElement>()

  const handleSubmit = async () => {
    if (
      !passwordField1.current?.value ||
      passwordField1.current?.value.length < 1
    ) {
      alert('Password is empty')
    } else if (
      passwordField1.current?.value !== passwordField2.current?.value
    ) {
      alert("The passwords don't match")
    } else {
      await onSubmitPassword(passwordField1.current?.value)
      onClose()
    }
  }

  return (
    <Dialog
      title={'Change your password'}
      hasSubmitButton={true}
      submitText="Update password"
      closeText="Cancel"
      onSubmit={handleSubmit}
      onClose={onClose}
    >
      <TextField
        placeholder="Enter your password here"
        style={textFieldStyle}
        type="password"
        inputRef={passwordField1}
      />

      <TextField
        placeholder="Enter it a second time please"
        style={textFieldStyle}
        type="password"
        inputRef={passwordField2}
      />
    </Dialog>
  )
}
